<mat-form-field
  [appearance]="appearance"
  class="w-full mg-input"
  [ngClass]="{
    'mg-input-small': size === 'small',
    'mg-input-medium': size === 'medium',
    'mg-input-no-padding': noPadding,
    '!text-right': rightAlign,
    'input-default': variant === 'default',
    'input-secondary': variant === 'secondary',
    'input-white': variant === 'white',
    'input-contrast': variant === 'contrast',
    'mg-input-textarea': type === 'textarea'
  }"
>
  @if (label) {
    <mat-label
      class="tracking-normal text-base"
      [ngClass]="{
        'text-error': isFormControlInvalid(),
        'text-txt':
          (variant === 'default' || variant === 'white' || variant === 'contrast') &&
          !isFormControlInvalid(),
        'text-txt-secondary': variant === 'secondary' && !isFormControlInvalid()
      }"
    >
      <span class="inline-block lowercase first-letter:uppercase">{{ label }}</span>
    </mat-label>
  }
  @if (prefix) {
    <span class="input-has-prefix" matPrefix>{{ prefix }} &nbsp;</span>
  }

  @switch (type) {
    @case ('select') {
      <ng-container *ngTemplateOutlet="selectInputTemplate"></ng-container>
    }
    @case ('date') {
      <ng-container *ngTemplateOutlet="datePickerTemplate"></ng-container>
    }
    @case ('google-places') {
      <ng-container *ngTemplateOutlet="googlePlacesInputTemplate"></ng-container>
    }
    @case ('textarea') {
      <ng-container *ngTemplateOutlet="textAreaTemplate"></ng-container>
    }
    @default {
      <ng-container *ngTemplateOutlet="normalInputTemplate"></ng-container>
    }
  }

  @if (loading) {
    <mat-progress-spinner matSuffix [diameter]="16" mode="indeterminate"> </mat-progress-spinner>
  }
  @if (!loading && icon && type !== 'password') {
    <ng-container matSuffix>
      @if (clearable && formControl.value && formControl.value !== '') {
        <svg-icon
          key="close"
          [color]="clearIconColor"
          [fontSize]="clearIconSize"
          (click)="formControl.reset()"
        ></svg-icon>
      } @else {
        <svg-icon
          [key]="icon"
          [color]="iconColor"
          [fontSize]="iconSize"
          (click)="iconClicked.emit($event)"
          class="{{ iconClass }}"
        ></svg-icon>
      }
    </ng-container>
  }
  @if (!loading && type === 'password') {
    <svg-icon
      matSuffix
      key="eye-light"
      [color]="iconColor"
      [fontSize]="iconSize"
      (click)="showPassword = !showPassword"
    ></svg-icon>
  }

  @if (isFormControlInvalid() && handleErrorMessage() !== '') {
    <mat-error class="text-sm text-error tracking-normal mt-xs">
      {{ handleErrorMessage() }}
    </mat-error>
  }

  <ng-template #normalInputTemplate ngProjectAs="[matInput]">
    @if (!useCurrencyMask) {
      <input
        [id]="normalInputId"
        class="{{ extraInputClass }}"
        [mask]="mask"
        [suffix]="suffix"
        matInput
        [type]="showPassword ? 'text' : type"
        [formControl]="formControl"
        [mgAutofocus]="autoFocus"
        [errorStateMatcher]="customErrorMatcher ? customErrorMatcher : errorMatcher"
        autocomplete="on"
        [placeholder]="placeholder"
        [ngClass]="{ 'text-center': normalInputCenter }"
        [attr.inputmode]="inputmode"
        (focus)="focused.emit()"
        (blur)="blured.emit()"
      />
    }
    @if (useCurrencyMask) {
      <input
        class="{{ extraInputClass }}"
        [currencyMask]="{ prefix: '$', align: 'left', allowNegative: false }"
        matInput
        type="text"
        [formControl]="formControl"
        [mgAutofocus]="autoFocus"
        [errorStateMatcher]="customErrorMatcher ? customErrorMatcher : errorMatcher"
        autocomplete="on"
        [placeholder]="placeholder"
        [ngClass]="{ 'text-center': normalInputCenter }"
        (focus)="focused.emit()"
        (blur)="blured.emit()"
      />
    }
  </ng-template>

  <ng-template #textAreaTemplate ngProjectAs="[matInput]">
    <textarea
      class="{{ extraInputClass }}"
      [mask]="mask"
      matInput
      [formControl]="formControl"
      [mgAutofocus]="autoFocus"
      [errorStateMatcher]="customErrorMatcher ? customErrorMatcher : errorMatcher"
      autocomplete="on"
      cdkTextareaAutosize
      [cdkAutosizeMinRows]="minTextAreaRows"
      [cdkAutosizeMaxRows]="maxTextAreaRows"
      [placeholder]="placeholder"
      (focus)="focused.emit()"
      (blur)="blured.emit()"
    ></textarea>
  </ng-template>

  <ng-template #googlePlacesInputTemplate ngProjectAs="[matInput]">
    <input
      matInput
      class="{{ extraInputClass }}"
      type="text"
      [formControl]="formControl"
      [mgAutofocus]="autoFocus"
      [errorStateMatcher]="customErrorMatcher ? customErrorMatcher : errorMatcher"
      id="google-places-input"
      [placeholder]="placeholder"
      (focus)="focused.emit()"
      (blur)="blured.emit()"
    />
  </ng-template>

  <ng-template #datePickerTemplate ngProjectAs="[matDatepicker]">
    <input
      matInput
      class="{{ extraInputClass }}"
      [matDatepicker]="picker"
      [formControl]="formControl"
      [max]="maxDate"
      (focus)="picker.open()"
      (click)="picker.open()"
      [placeholder]="placeholder"
      (focus)="focused.emit()"
      (blur)="blured.emit()"
    />
    <mat-datepicker #picker></mat-datepicker>
  </ng-template>

  <ng-template #selectInputTemplate ngProjectAs="mat-select">
    <mat-select
      [formControl]="formControl"
      disableOptionCentering
      panelClass="mg-select-panel {{ extraSelectPanelClass }}"
    >
      @for (item of items; track item.value) {
        <mat-option [value]="item.value" [disabled]="item.disabled">
          {{ item.label }}
        </mat-option>
      }
    </mat-select>
  </ng-template>
</mat-form-field>
